// extracted by mini-css-extract-plugin
export var copyableField = "_lu-4";
export var customerBadge = "_lu-0";
export var customerInfoTitle = "_lu-2";
export var details = "_lu-1";
export var dropdownContainer = "_lu-5";
export var dropdownImage = "_lu-6";
export var editAssigneeForm = "_lu-a";
export var editButton = "_lu-3";
export var email = "_lu-7";
export var hidden = "_lu-d";
export var input = "_lu-8";
export var saveButton = "_lu-b";
export var shopifyIcon = "_lu-c";
export var suggestionBadge = "_lu-e";
export var suggestionText = "_lu-f";
export var username = "_lu-9";